export interface MuteButtonCallbacks {
  onToggle: (muted: boolean) => void;
}

export class MuteButton {
  private root: HTMLDivElement;
  private btn: HTMLButtonElement;
  private muted = false;

  constructor(host: HTMLElement, cb: MuteButtonCallbacks) {
    this.root = document.createElement('div');
    this.root.className = 'layer mute hidden';
    this.root.innerHTML = `<button class="mute-btn" aria-label="静音">🔊</button>`;
    host.appendChild(this.root);
    this.btn = this.root.querySelector('.mute-btn') as HTMLButtonElement;
    this.btn.addEventListener('click', () => {
      this.muted = !this.muted;
      this.btn.textContent = this.muted ? '🔇' : '🔊';
      cb.onToggle(this.muted);
    });
  }

  show(): void {
    this.root.classList.remove('hidden');
  }

  hide(): void {
    this.root.classList.add('hidden');
  }

  setMuted(b: boolean): void {
    this.muted = b;
    this.btn.textContent = b ? '🔇' : '🔊';
  }
}
